import {State} from 'app/setup';

/** Selectors for the system shell state. */
export const simpleSystemSelector = {
    refreshModalVisible: ({system}: State): boolean => system.refreshModalVisible,
    serverError: ({system}: State): boolean => system.serverError,
};
